import { Navbar } from "./navbar";
import { Footer } from "./footer";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-stretch">
      <Navbar />
      <main className="flex-1 py-4 sm:py-6 md:py-8 pt-20 sm:pt-22 md:pt-24 lg:pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
}
